// src/store/services/users.js
import feathersClient, { BaseModel, makeServicePlugin } from '../../feathers-client';
export class QueueManagement extends BaseModel {
    constructor(data, options) {
        super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'QueueManagement';
    // Define default properties here
    static instanceDefaults() {
        return {
            state: '',
            feedId: ''
        };
    }
}
const servicePath = 'queue-management';
const servicePlugin = makeServicePlugin({
    Model: QueueManagement,
    service: feathersClient.service(servicePath),
    servicePath,
});
// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: [],
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: [],
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: [],
    },
});
export default servicePlugin;
